import { removeDataValue } from '@juvare/json-data-util';
export function removeValuesFromComponentDependencies(newData, dataPath, filterDependencies) {
    const dependantFilterArray = filterDependencies === null || filterDependencies === void 0 ? void 0 : filterDependencies[dataPath];
    if (dependantFilterArray && dependantFilterArray.length > 0) {
        dependantFilterArray.forEach((dependantFilterKey) => {
            removeDataValue(newData, dependantFilterKey);
        });
    }
}
